import { Locale } from '@/interfaces/api/general/language';
import { FormItem } from '@/interfaces/lib/model';

export type TextByLocale = Record<Locale, string>;

export class MultiLanguageItem {
  id: number | string;
  text: TextByLocale;

  constructor(id: number | string, text: TextByLocale) {
    this.id = id;
    this.text = text;
  }

  toFormItem = (locale: Locale): FormItem => ({
    value: this.id,
    text: this.text[locale],
  });

  value = (locale: Locale) => this.text[locale];
}
